import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-dent',
  templateUrl: './dent.component.html',
  styleUrls: ['./dent.component.scss'],
})
export class DentComponent implements OnInit {
  @Input() selectedTeeth: any[] = [];

  // Émetteur pour envoyer les modifications au parent
  @Output() teethUpdated = new EventEmitter<string[]>();
ngOnChanges(changes: SimpleChanges): void {
  if (changes['selectedTeeth']) {
    // console.log("selectedTeeth", this.selectedTeeth);

    if (this.selectedTeeth && Array.isArray(this.selectedTeeth)) {
      // ✅ Si l'image n'est pas encore chargée, attendre avant de dessiner
      if (this.imageLoaded) {
        this.onChangeTraitement(this.selectedTeeth);
      } else {
        const img = document.getElementById('teeth') as HTMLImageElement;
        img.onload = () => {
          this.imageLoaded = true;
          this.onChangeTraitement(this.selectedTeeth);
        };
      }
    }
  }
}




  pointSize = 4;
  element: Element;
  root: Element;
  ctx;
  canvas;
  data = [];
  url = 'assets/img/all_teeth.jpg';

  public idUser;
  idPersonne: number;
  photoNumber: number;

  ischeck18: boolean = false;
  ischeck17: boolean = false;
  ischeck16: boolean = false;
  ischeck15: boolean = false;
  ischeck14: boolean = false;
  ischeck13: boolean = false;
  ischeck12: boolean = false;
  ischeck11: boolean = false;
  ischeck21: boolean = false;
  ischeck22: boolean = false;
  ischeck23: boolean = false;
  ischeck24: boolean = false;
  ischeck25: boolean = false;
  ischeck26: boolean = false;
  ischeck27: boolean = false;
  ischeck28: boolean = false;
  ischeck48: boolean = false;
  ischeck47: boolean = false;
  ischeck46: boolean = false;
  ischeck45: boolean = false;
  ischeck44: boolean = false;
  ischeck43: boolean = false;
  ischeck42: boolean = false;
  ischeck41: boolean = false;
  ischeck31: boolean = false;
  ischeck32: boolean = false;
  ischeck33: boolean = false;
  ischeck34: boolean = false;
  ischeck35: boolean = false;
  ischeck36: boolean = false;
  ischeck37: boolean = false;
  ischeck38: boolean = false;

  ischeck55: boolean = false;
  ischeck54: boolean = false;
  ischeck53: boolean = false;
  ischeck52: boolean = false;
  ischeck51: boolean = false;
  ischeck61: boolean = false;
  ischeck62: boolean = false;
  ischeck63: boolean = false;
  ischeck64: boolean = false;
  ischeck65: boolean = false;
  ischeck85: boolean = false;
  ischeck84: boolean = false;
  ischeck83: boolean = false;
  ischeck82: boolean = false;
  ischeck81: boolean = false;
  ischeck71: boolean = false;
  ischeck72: boolean = false;
  ischeck73: boolean = false;
  ischeck74: boolean = false;
  ischeck75: boolean = false;

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() {
    console.log(this.selectedTeeth);
    this.myCanvas();
    this.onChangeTraitement(this.selectedTeeth);

  }
myCanvas() {
  console.log("i'm here");
  
  this.canvas = document.getElementById('canvas') as HTMLCanvasElement;
  this.ctx = this.canvas.getContext('2d');

  const img = document.getElementById('teeth') as HTMLImageElement;

  if (this.imageLoaded) {
    this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
  } else {
    // attendre le chargement
    img.onload = () => {
      this.imageLoaded = true;
      this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
    };
  }
}

myCanvasafterdelete() {
  this.canvas = document.getElementById('canvas') as HTMLCanvasElement;
  this.ctx = this.canvas.getContext('2d');

  const img = document.getElementById('teeth') as HTMLImageElement;
  if (this.imageLoaded) {
    this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
  }
}

onImageLoaded() {
  this.imageLoaded = true;
  if (this.ctx && this.canvas) {
    const img = document.getElementById('teeth') as HTMLImageElement;
    this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
  }
}

  getPosition(event) {
    console.log("event",event);
    
    this.element = <Element>this.root;
    this.canvas = <HTMLCanvasElement>document.getElementById('canvas');
    this.ctx = this.canvas.getContext('2d');
    let curleft = 0,
      curtop = 0;
    var id = 0;
    var numteeth = 0;

    curleft += event.offsetX;
    curtop += event.offsetY;

    if (this.data.length > 0) {
      id = this.data[this.data.length - 1].id + 1;
    }
    var p = { id: id, x: curleft, y: curtop, numteeth: numteeth };
    // console.log("p",p);
    // console.log("data",this.data);

    this.data.push(p);
    this.teethUpdated.emit(this.data);
    this.draw(this.data);
    //for emptying data[]
    //this.data.splice(0,1);
  }

  draw(data) {
    // console.log("data",data);
    
    for (let i = 0; i < data.length; i++) {
      // this.drawcircle(data[i]);
    // console.log("this.ischeck11",this.ischeck11);

      if (this.ischeck11 == false) {
        this.teeth11(data[i]);
      }
      if (this.ischeck12 == false) {
        this.teeth12(data[i]);
      }
      if (this.ischeck18 == false) {
        this.teeth18(data[i]);
      }
      if (this.ischeck17 == false) {
        this.teeth17(data[i]);
      }
      if (this.ischeck16 == false) {
        this.teeth16(data[i]);
      }
      if (this.ischeck15 == false) {
        this.teeth15(data[i]);
      }
      if (this.ischeck14 == false) {
        this.teeth14(data[i]);
      }
      if (this.ischeck13 == false) {
        this.teeth13(data[i]);
      }
      if (this.ischeck21 == false) {
        this.teeth21(data[i]);
      }
      if (this.ischeck22 == false) {
        this.teeth22(data[i]);
      }
      if (this.ischeck23 == false) {
        this.teeth23(data[i]);
      }
      if (this.ischeck24 == false) {
        this.teeth24(data[i]);
      }
      if (this.ischeck25 == false) {
        this.teeth25(data[i]);
      }
      if (this.ischeck26 == false) {
        this.teeth26(data[i]);
      }
      if (this.ischeck27 == false) {
        this.teeth27(data[i]);
      }
      if (this.ischeck28 == false) {
        this.teeth28(data[i]);
      }
      if (this.ischeck48 == false) {
        this.teeth48(data[i]);
      }
      if (this.ischeck47 == false) {
        this.teeth47(data[i]);
      }
      if (this.ischeck46 == false) {
        this.teeth46(data[i]);
      }
      if (this.ischeck45 == false) {
        this.teeth45(data[i]);
      }
      if (this.ischeck44 == false) {
        this.teeth44(data[i]);
      }
      if (this.ischeck43 == false) {
        this.teeth43(data[i]);
      }
      if (this.ischeck42 == false) {
        this.teeth42(data[i]);
      }
      if (this.ischeck41 == false) {
        this.teeth41(data[i]);
      }
      if (this.ischeck31 == false) {
        this.teeth31(data[i]);
      }
      if (this.ischeck32 == false) {
        this.teeth32(data[i]);
      }
      if (this.ischeck33 == false) {
        this.teeth33(data[i]);
      }
      if (this.ischeck34 == false) {
        this.teeth34(data[i]);
      }
      if (this.ischeck35 == false) {
        this.teeth35(data[i]);
      }
      if (this.ischeck36 == false) {
        this.teeth36(data[i]);
      }
      if (this.ischeck37 == false) {
        this.teeth37(data[i]);
      }
      if (this.ischeck38 == false) {
        this.teeth38(data[i]);
      }

      if (this.ischeck55 == false) {
        this.teeth55(data[i]);
      }
      if (this.ischeck54 == false) {
        this.teeth54(data[i]);
      }
      if (this.ischeck53 == false) {
        this.teeth53(data[i]);
      }
      if (this.ischeck52 == false) {
        this.teeth52(data[i]);
      }
      if (this.ischeck51 == false) {
        this.teeth51(data[i]);
      }
      if (this.ischeck61 == false) {
        this.teeth61(data[i]);
      }
      if (this.ischeck62 == false) {
        this.teeth62(data[i]);
      }
      if (this.ischeck63 == false) {
        this.teeth63(data[i]);
      }
      if (this.ischeck64 == false) {
        this.teeth64(data[i]);
      }
      if (this.ischeck65 == false) {
        this.teeth65(data[i]);
      }
      if (this.ischeck85 == false) {
        this.teeth85(data[i]);
      }
      if (this.ischeck84 == false) {
        this.teeth84(data[i]);
      }
      if (this.ischeck83 == false) {
        this.teeth83(data[i]);
      }
      if (this.ischeck82 == false) {
        this.teeth82(data[i]);
      }
      if (this.ischeck81 == false) {
        this.teeth81(data[i]);
      }
      if (this.ischeck71 == false) {
        this.teeth71(data[i]);
      }
      if (this.ischeck72 == false) {
        this.teeth72(data[i]);
      }
      if (this.ischeck73 == false) {
        this.teeth73(data[i]);
      }
      if (this.ischeck74 == false) {
        this.teeth74(data[i]);
      }
      if (this.ischeck75 == false) {
        this.teeth75(data[i]);
      }

      if (this.data[i].numteeth === 0) {
        this.data.splice(i, 1);

      }
    }
  }
  //function for testing
  drawcircle(data) {
    const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

    grd.addColorStop(0, 'red');
    this.ctx.fillStyle = grd; // Red color
    this.ctx.strokeStyle = grd;

    this.ctx.beginPath();
    this.ctx.arc(
      Number(data.x),
      Number(data.y),
      this.pointSize,
      0,
      Math.PI * 2,
      true
    );
    this.ctx.fill();
    //this.ctx.stroke();

    const coord = 'x=' + data.x + ', y=' + data.y;
    const p = this.ctx.getImageData(data.x, data.y, 1, 1).data;
    const X = data.x;
    const Y = data.y;
    // console.log('X : ' + X + ' | Y : ' + Y);
  }
  removeteeth(point) {
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].id === point.id) {
        // console.log('removing item at position: ' + i);
        // console.log('point ' + point);
        this.data.splice(i, 1);
        this.teethUpdated.emit(this.data);
        this.ischeck11 = false;
        this.ischeck12 = false;
        this.ischeck13 = false;
        this.ischeck14 = false;
        this.ischeck15 = false;
        this.ischeck16 = false;
        this.ischeck17 = false;
        this.ischeck18 = false;
        this.ischeck21 = false;
        this.ischeck22 = false;
        this.ischeck23 = false;
        this.ischeck24 = false;
        this.ischeck25 = false;
        this.ischeck26 = false;
        this.ischeck27 = false;
        this.ischeck28 = false;
        this.ischeck48 = false;
        this.ischeck47 = false;
        this.ischeck46 = false;
        this.ischeck45 = false;
        this.ischeck44 = false;
        this.ischeck43 = false;
        this.ischeck42 = false;
        this.ischeck41 = false;
        this.ischeck31 = false;
        this.ischeck32 = false;
        this.ischeck33 = false;
        this.ischeck34 = false;
        this.ischeck35 = false;
        this.ischeck36 = false;
        this.ischeck37 = false;
        this.ischeck38 = false;

        this.ischeck55 = false;
        this.ischeck54 = false;
        this.ischeck53 = false;
        this.ischeck52 = false;
        this.ischeck51 = false;
        this.ischeck61 = false;
        this.ischeck62 = false;
        this.ischeck63 = false;
        this.ischeck64 = false;
        this.ischeck65 = false;
        this.ischeck85 = false;
        this.ischeck84 = false;
        this.ischeck83 = false;
        this.ischeck82 = false;
        this.ischeck81 = false;
        this.ischeck71 = false;
        this.ischeck72 = false;
        this.ischeck73 = false;
        this.ischeck74 = false;
        this.ischeck75 = false;
      }
    }
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.myCanvasafterdelete();
    this.draw(this.data);
  }

  teeth11(data) {
    const x0 = 219;
    const y0 = 98;
    const x1 = 244;
    const y1 = 120;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(232, 108, 15, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      // console.log('you check this teeth 11');
      this.ischeck11 = true;
      data.numteeth = 11;
    }
  }

  teeth12(data) {
    const x0 = 199;
    const y0 = 109;
    const x1 = 218;
    const y1 = 128;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(209, 114, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 12;
      // console.log('you check this teeth 12');
      this.ischeck12 = true;
    }
  }

  teeth18(data) {
    const x0 = 136;
    const y0 = 266;
    const x1 = 156;
    const y1 = 300;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(148, 283, 16, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 18;
      // console.log('you check this teeth 18');
      this.ischeck18 = true;
    }
  }
  teeth17(data) {
    const x0 = 139;
    const y0 = 227;
    const x1 = 160;
    const y1 = 263;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(149, 246, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 17;
      console.log('you check this teeth 17');
      this.ischeck17 = true;
    }
  }
  teeth16(data) {
    const x0 = 146;
    const y0 = 186;
    const x1 = 169;
    const y1 = 226;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(158, 207, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 16;
      console.log('you check this teeth 16');
      this.ischeck16 = true;
    }
  }
  teeth15(data) {
    const x0 = 164;
    const y0 = 161;
    const x1 = 175;
    const y1 = 189;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(168, 174, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 15;
      console.log('you check this teeth 15');
      this.ischeck15 = true;
    }
  }
  teeth14(data) {
    const x0 = 172;
    const y0 = 136;
    const x1 = 185;
    const y1 = 163;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(180, 149, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 14;
      console.log('you check this teeth 14');
      this.ischeck14 = true;
    }
  }
  teeth13(data) {
    const x0 = 182;
    const y0 = 118;
    const x1 = 199;
    const y1 = 141;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(192, 129, 13, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 13;
      console.log('you check this teeth 13');
      this.ischeck13 = true;
    }
  }
  teeth21(data) {
    const x0 = 248;
    const y0 = 97;
    const x1 = 269;
    const y1 = 119;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(261, 107, 15, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 21;
      console.log('you check this teeth 21');
      this.ischeck21 = true;
    }
  }
  teeth22(data) {
    const x0 = 278;
    const y0 = 106;
    const x1 = 292;
    const y1 = 126;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(285, 116, 13, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 22;
      console.log('you check this teeth 22');
      this.ischeck22 = true;
    }
  }
  teeth23(data) {
    const x0 = 296;
    const y0 = 119;
    const x1 = 314;
    const y1 = 136;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(305, 129, 13, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 23;
      console.log('you check this teeth 23');
      this.ischeck23 = true;
    }
  }
  teeth24(data) {
    const x0 = 300;
    const y0 = 143;
    const x1 = 327;
    const y1 = 157;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(314, 150, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 24;
      console.log('you check this teeth 24');
      this.ischeck24 = true;
    }
  }
  teeth25(data) {
    const x0 = 312;
    const y0 = 166;
    const x1 = 338;
    const y1 = 182;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(326, 175, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 25;
      console.log('you check this teeth 25');
      this.ischeck25 = true;
    }
  }
  teeth26(data) {
    const x0 = 316;
    const y0 = 195;
    const x1 = 353;
    const y1 = 222;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(336, 208, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 26;
      console.log('you check this teeth 26');
      this.ischeck26 = true;
    }
  }
  teeth27(data) {
    const x0 = 328;
    const y0 = 233;
    const x1 = 359;
    const y1 = 260;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(344, 246, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 27;
      console.log('you check this teeth 27');
      this.ischeck27 = true;
    }
  }
  teeth28(data) {
    const x0 = 332;
    const y0 = 269;
    const x1 = 361;
    const y1 = 298;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(347, 284, 17, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 28;
      console.log('you check this teeth 28');
      this.ischeck28 = true;
    }
  }
  teeth48(data) {
    const x0 = 136;
    const y0 = 338;
    const x1 = 162;
    const y1 = 366;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(150, 353, 17, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 48;
      console.log('you check this teeth 48');
      this.ischeck48 = true;
    }
  }
  teeth47(data) {
    const x0 = 137;
    const y0 = 374;
    const x1 = 171;
    const y1 = 403;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(154, 390, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 28;
      console.log('you check this teeth 28');
      this.ischeck28 = true;
    }
  }
  teeth46(data) {
    const x0 = 146;
    const y0 = 418;
    const x1 = 182;
    const y1 = 442;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(164, 430, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 46;
      console.log('you check this teeth 46');
      this.ischeck46 = true;
    }
  }
  teeth45(data) {
    const x0 = 162;
    const y0 = 454;
    const x1 = 187;
    const y1 = 470;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(175, 462, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 45;
      console.log('you check this teeth 45');
      this.ischeck45 = true;
    }
  }
  teeth44(data) {
    const x0 = 175;
    const y0 = 478;
    const x1 = 198;
    const y1 = 491;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(188, 485, 13, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 44;
      console.log('you check this teeth 44');
      this.ischeck44 = true;
    }
  }
  teeth43(data) {
    const x0 = 192;
    const y0 = 498;
    const x1 = 208;
    const y1 = 515;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(202, 505, 13, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 43;
      console.log('you check this teeth 43');
      this.ischeck43 = true;
    }
  }
  teeth42(data) {
    const x0 = 214;
    const y0 = 504;
    const x1 = 227;
    const y1 = 526;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(220, 516, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 42;
      console.log('you check this teeth 42');
      this.ischeck42 = true;
    }
  }
  teeth41(data) {
    const x0 = 231;
    const y0 = 510;
    const x1 = 246;
    const y1 = 529;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(238, 521, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 41;
      console.log('you check this teeth 41');
      this.ischeck41 = true;
    }
  }
  teeth31(data) {
    const x0 = 249;
    const y0 = 510;
    const x1 = 265;
    const y1 = 528;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(257, 521, 11, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 31;
      console.log('you check this teeth 31');
      this.ischeck31 = true;
    }
  }
  teeth32(data) {
    const x0 = 268;
    const y0 = 508;
    const x1 = 285;
    const y1 = 521;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(275, 516, 11, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 32;
      console.log('you check this teeth 32');
      this.ischeck32 = true;
    }
  }
  teeth33(data) {
    const x0 = 283;
    const y0 = 494;
    const x1 = 303;
    const y1 = 512;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(294, 504, 11, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 33;
      console.log('you check this teeth 33');
      this.ischeck33 = true;
    }
  }
  teeth34(data) {
    const x0 = 299;
    const y0 = 473;
    const x1 = 316;
    const y1 = 498;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(308, 486, 13, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 34;
      console.log('you check this teeth 34');
      this.ischeck34 = true;
    }
  }
  teeth35(data) {
    const x0 = 314;
    const y0 = 449;
    const x1 = 328;
    const y1 = 475;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(320, 462, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 35;
      console.log('you check this teeth 35');
      this.ischeck35 = true;
    }
  }
  teeth36(data) {
    const x0 = 320;
    const y0 = 410;
    const x1 = 344;
    const y1 = 448;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(332, 429, 19, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 36;
      console.log('you check this teeth 36');
      this.ischeck36 = true;
    }
  }
  teeth37(data) {
    const x0 = 329;
    const y0 = 371;
    const x1 = 355;
    const y1 = 409;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(343, 391, 19, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 37;
      console.log('you check this teeth 37');
      this.ischeck37 = true;
    }
  }
  teeth38(data) {
    const x0 = 334;
    const y0 = 335;
    const x1 = 359;
    const y1 = 368;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(347, 352, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 38;
      console.log('you check this teeth 38');
      this.ischeck38 = true;
    }
  }
  teeth55(data) {
    const x0 = 177;
    const y0 = 273;
    const x1 = 202;
    const y1 = 302;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(189, 290, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 55;
      console.log('you check this teeth 55');
      this.ischeck55 = true;
    }
  }
  teeth54(data) {
    const x0 = 184;
    const y0 = 242;
    const x1 = 202;
    const y1 = 272;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(194, 257, 17, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 54;
      console.log('you check this teeth 54');
      this.ischeck54 = true;
    }
  }
  teeth53(data) {
    const x0 = 192;
    const y0 = 220;
    const x1 = 210;
    const y1 = 241;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(202, 232, 13, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 53;
      console.log('you check this teeth 53');
      this.ischeck53 = true;
    }
  }
  teeth52(data) {
    const x0 = 205;
    const y0 = 203;
    const x1 = 222;
    const y1 = 225;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(214, 214, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 52;
      console.log('you check this teeth 52');
      this.ischeck52 = true;
    }
  }
  teeth51(data) {
    const x0 = 223;
    const y0 = 198;
    const x1 = 244;
    const y1 = 215;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(235, 204, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 51;
      console.log('you check this teeth 51');
      this.ischeck51 = true;
    }
  }
  teeth61(data) {
    const x0 = 250;
    const y0 = 195;
    const x1 = 268;
    const y1 = 215;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(260, 205, 14, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 61;
      console.log('you check this teeth 61');
      this.ischeck61 = true;
    }
  }
  teeth62(data) {
    const x0 = 276;
    const y0 = 202;
    const x1 = 288;
    const y1 = 222;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(282, 214, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 62;
      console.log('you check this teeth 62');
      this.ischeck62 = true;
    }
  }
  teeth63(data) {
    const x0 = 285;
    const y0 = 226;
    const x1 = 304;
    const y1 = 238;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(296, 231, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 63;
      console.log('you check this teeth 63');
      this.ischeck63 = true;
    }
  }
  teeth64(data) {
    const x0 = 288;
    const y0 = 247;
    const x1 = 315;
    const y1 = 266;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(302, 258, 16, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 64;
      console.log('you check this teeth 64');
      this.ischeck64 = true;
    }
  }
  teeth65(data) {
    const x0 = 293;
    const y0 = 275;
    const x1 = 320;
    const y1 = 303;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(306, 290, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 65;
      console.log('you check this teeth 65');
      this.ischeck65 = true;
    }
  }
  teeth85(data) {
    const x0 = 179;
    const y0 = 338;
    const x1 = 207;
    const y1 = 364;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(192, 350, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 85;
      console.log('you check this teeth 85');
      this.ischeck85 = true;
    }
  }
  teeth84(data) {
    const x0 = 184;
    const y0 = 373;
    const x1 = 211;
    const y1 = 394;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(198, 384, 17, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 84;
      console.log('you check this teeth 84');
      this.ischeck84 = true;
    }
  }
  teeth83(data) {
    const x0 = 196;
    const y0 = 403;
    const x1 = 213;
    const y1 = 418;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(206, 410, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 83;
      console.log('you check this teeth 83');
      this.ischeck83 = true;
    }
  }
  teeth82(data) {
    const x0 = 216;
    const y0 = 416;
    const x1 = 228;
    const y1 = 434;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(223, 426, 10, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 82;
      console.log('you check this teeth 82');
      this.ischeck82 = true;
    }
  }
  teeth81(data) {
    const x0 = 234;
    const y0 = 423;
    const x1 = 248;
    const y1 = 440;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(240, 434, 10, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 81;
      console.log('you check this teeth 81');
      this.ischeck81 = true;
    }
  }
  teeth71(data) {
    const x0 = 250;
    const y0 = 423;
    const x1 = 264;
    const y1 = 439;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(257, 432, 10, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 71;
      console.log('you check this teeth 71');
      this.ischeck71 = true;
    }
  }
  teeth72(data) {
    const x0 = 267;
    const y0 = 416;
    const x1 = 284;
    const y1 = 429;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(274, 425, 10, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 72;
      console.log('you check this teeth 72');
      this.ischeck72 = true;
    }
  }
  teeth73(data) {
    const x0 = 282;
    const y0 = 399;
    const x1 = 297;
    const y1 = 420;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(291, 409, 12, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 73;
      console.log('you check this teeth 73');
      this.ischeck73 = true;
    }
  }
  teeth74(data) {
    const x0 = 289;
    const y0 = 367;
    const x1 = 308;
    const y1 = 398;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(300, 384, 16, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 74;
      console.log('you check this teeth 74');
      this.ischeck74 = true;
    }
  }
  teeth75(data) {
    const x0 = 292;
    const y0 = 334;
    const x1 = 315;
    const y1 = 366;
    if (
      Number(data.x) >= x0 &&
      Number(data.x) <= x1 &&
      Number(data.y) >= y0 &&
      Number(data.y) <= y1
    ) {
      const grd = this.ctx.createLinearGradient(0, 0, 170, 0);

      grd.addColorStop(0, 'red');
      this.ctx.fillStyle = grd; // Red color
      this.ctx.strokeStyle = grd;

      this.ctx.beginPath();
      this.ctx.arc(304, 350, 18, 0, Math.PI * 2, true);
      //this.ctx.fill();
      this.ctx.stroke();
      data.numteeth = 75;
      console.log('you check this teeth 75');
      this.ischeck75 = true;
    }
  }
onChangeTraitement(array) {
  // console.log("i'm in onChangeTraitement");
  
  this.data = [];
  this.resetAllPoint();

  if (!array || !Array.isArray(array)) return;

  for (let index = 0; index < array.length; index++) {
    this.data.push(array[index]);
  }

  // ⏱️ Petit délai pour s'assurer que le canvas et l'image sont prêts
  setTimeout(() => {
    this.myCanvasafterdelete();
    this.draw(this.data);
  }, 100);
}


private imageLoaded = false;

  resetAllPoint(){
    this.ischeck11 = false;
    this.ischeck12 = false;
    this.ischeck13 = false;
    this.ischeck14 = false;
    this.ischeck15 = false;
    this.ischeck16 = false;
    this.ischeck17 = false;
    this.ischeck18 = false;
    this.ischeck21 = false;
    this.ischeck22 = false;
    this.ischeck23 = false;
    this.ischeck24 = false;
    this.ischeck25 = false;
    this.ischeck26 = false;
    this.ischeck27 = false;
    this.ischeck28 = false;
    this.ischeck48 = false;
    this.ischeck47 = false;
    this.ischeck46 = false;
    this.ischeck45 = false;
    this.ischeck44 = false;
    this.ischeck43 = false;
    this.ischeck42 = false;
    this.ischeck41 = false;
    this.ischeck31 = false;
    this.ischeck32 = false;
    this.ischeck33 = false;
    this.ischeck34 = false;
    this.ischeck35 = false;
    this.ischeck36 = false;
    this.ischeck37 = false;
    this.ischeck38 = false;

    this.ischeck55 = false;
    this.ischeck54 = false;
    this.ischeck53 = false;
    this.ischeck52 = false;
    this.ischeck51 = false;
    this.ischeck61 = false;
    this.ischeck62 = false;
    this.ischeck63 = false;
    this.ischeck64 = false;
    this.ischeck65 = false;
    this.ischeck85 = false;
    this.ischeck84 = false;
    this.ischeck83 = false;
    this.ischeck82 = false;
    this.ischeck81 = false;
    this.ischeck71 = false;
    this.ischeck72 = false;
    this.ischeck73 = false;
    this.ischeck74 = false;
    this.ischeck75 = false;
  }



}
